import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VImg,{staticClass:"board-space-image",attrs:{"src":_vm.spacePath(_vm.value.kind)}})}
var staticRenderFns = []

export { render, staticRenderFns }